import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Spin, Typography } from 'antd';
import { Link } from 'react-router-dom';
import ReminderService, { ReminderDashboardSummary } from '../../services/ReminderService';

const { Text } = Typography;

type ReminderSummaryMode = 'admin' | 'me';
type ReminderSummaryScope = 'prev' | 'today' | 'next';
type ReminderCountMap = Record<ReminderSummaryScope, number>;

interface ReminderSummaryCardsProps {
  title?: string;
  mode?: ReminderSummaryMode;
}

const SUMMARY_ITEMS: Array<{
  key: ReminderSummaryScope;
  label: string;
  link: string;
}> = [
  { key: 'prev', label: 'Önceki', link: '/reminders?scope=prev&state=PENDING' },
  { key: 'today', label: 'Bugün', link: '/reminders?scope=today&state=PENDING' },
  // { key: 'next', label: 'Sonraki', link: '/reminders?scope=next&state=PENDING' },
];

const createEmptyCounts = (): ReminderCountMap => ({
  prev: 0,
  today: 0,
  next: 0,
});

const ReminderSummaryCards: React.FC<ReminderSummaryCardsProps> = ({
  title = 'Beklemede Olan Görevler',
  mode = 'me',
}) => {
  const [loading, setLoading] = useState(true);
  const [counts, setCounts] = useState<ReminderCountMap>(createEmptyCounts());

  useEffect(() => {
    let ignore = false;

    const loadCounts = async () => {
      setLoading(true);
      try {
        const response = await ReminderService.getDashboardSummary(mode);
        const summary = (response?.data ?? response ?? {}) as Partial<ReminderDashboardSummary>;

        if (ignore) {
          return;
        }

        setCounts({
          prev: Number(summary.prevCount ?? 0),
          today: Number(summary.todayCount ?? 0),
          next: Number(summary.nextCount ?? 0),
        });
      } catch (error) {
        console.error('Görev özet sayıları alınamadı:', error);
        if (!ignore) {
          setCounts(createEmptyCounts());
        }
      } finally {
        if (!ignore) {
          setLoading(false);
        }
      }
    };

    loadCounts();

    return () => {
      ignore = true;
    };
  }, [mode]);

  const visibleTotal = SUMMARY_ITEMS.reduce((total, item) => total + counts[item.key], 0);

  return (
    <Card
      bordered={false}
      style={{
        background: '#fff',
        borderRadius: 8,
        width: '100%',
      }}
      bodyStyle={{ padding: 20 }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 18, color: '#333', fontWeight: 700 }}>{title}</div>
          <Text type="secondary">Bekleyen Görevler</Text>
        </div>
        <div style={{ color: visibleTotal === 0 ? '#52c41a' : '#f5222d', fontWeight: 700, fontSize: 28 }}>
          {loading ? <Spin size="small" /> : visibleTotal}
        </div>
      </div>

      <Row gutter={[16, 16]}>
        {SUMMARY_ITEMS.map((item) => {
          const count = counts[item.key];

          return (
            <Col xs={24} md={12} key={item.key}>
              <Link to={item.link} style={{ display: 'block', width: '100%' }}>
                <div
                  className="dashboard-card-clickable"
                  style={{
                    background: '#f7f8fb',
                    borderRadius: 8,
                    minHeight: 92,
                    padding: 16,
                  }}
                >
                  <div style={{     borderLeft: `3px solid ${count === 0 ? '#52c41a' : '#f5222d'}`,
 paddingLeft: 12 }}>
                    <div style={{ color: '#8c8c8c', fontSize: 13, minHeight: 22 }}>{item.label}</div>
                    <div style={{ color: count === 0 ? '#52c41a' : '#f5222d', fontSize: 24, fontWeight: 700 }}>
                      {loading ? <Spin size="small" /> : count}
                    </div>
                  </div>
                </div>
              </Link>
            </Col>
          );
        })}
      </Row>
    </Card>
  );
};

export default ReminderSummaryCards;
